import HttpFactory from '../factory'

class MedocModule extends HttpFactory<any[]> {
  private PATH = '/'

  async send(data: any): Promise<any> {
    return await this.call<any>('POST', `${this.PATH}send`, data)
  }
}

export default MedocModule
